// Web-only strings for the people feature (keys prefixed `web.people.`), BOTH languages. Apple keys
// (people.*, browse.*, createChannel.*, profile.*) are used wherever they exist; these are the gaps.
// The profile's local-time and deactivated lines are Android's own wording (profile_field_local_time,
// profile_deactivated_explanation, user_deactivated).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.people.pickHint': 'Elige hasta 7 personas.',
    'web.people.targetDirect': 'Mensaje directo',
    'web.people.targetSelf': 'Tu espacio personal',
    'web.people.targetGroup': 'Grupo con %d personas más',
    'web.people.limitReached': 'Un grupo admite hasta 7 personas además de ti.',
    'web.people.deactivatedRefused': 'No se puede escribir a una cuenta desactivada.',
    'web.people.noMatches': 'Nadie coincide con «%@».',
    'web.people.removeChip': 'Quitar a %@',
    'web.people.searching': 'Buscando…',
    'web.people.closedFilter': 'Buscar conversaciones cerradas',
    'web.people.closedHint': 'Cerrar no borra nada: reabierta, vuelve con todo su historial.',
    'web.people.browse.search': 'Buscar canales',
    'web.people.browse.members': '%d miembros',
    'web.people.browse.membersOne': '1 miembro',
    'web.people.browse.joined': 'Ya eres miembro',
    'web.people.browse.joinFailed': 'No se pudo unir al canal.',
    'web.people.browse.noMatches': 'Ningún canal público coincide con «%@».',
    'web.people.create.public': 'Público',
    'web.people.create.private': 'Privado',
    'web.people.create.nameHint': 'Entre 2 y 64 caracteres.',
    'web.people.profile.localTime': 'Hora local',
    'web.people.profile.deactivated': 'Esta cuenta está desactivada. Puedes leer el historial, pero no puedes enviar mensajes nuevos.',
    'web.people.profile.deactivatedBadge': 'Desactivado',
    'web.people.profile.copyUsername': 'Copiar @usuario',
    'web.people.profile.copied': 'Copiado',
    'web.people.profile.you': 'Tú',
  },
  en: {
    'web.people.pickHint': 'Pick up to 7 people.',
    'web.people.targetDirect': 'Direct message',
    'web.people.targetSelf': 'Your personal space',
    'web.people.targetGroup': 'Group with %d other people',
    'web.people.limitReached': 'A group holds up to 7 people besides you.',
    'web.people.deactivatedRefused': 'You cannot write to a deactivated account.',
    'web.people.noMatches': 'No one matches “%@”.',
    'web.people.removeChip': 'Remove %@',
    'web.people.searching': 'Searching…',
    'web.people.closedFilter': 'Search closed conversations',
    'web.people.closedHint': 'Closing deletes nothing: reopened, it comes back with all its history.',
    'web.people.browse.search': 'Search channels',
    'web.people.browse.members': '%d members',
    'web.people.browse.membersOne': '1 member',
    'web.people.browse.joined': "You're a member",
    'web.people.browse.joinFailed': "Couldn't join the channel.",
    'web.people.browse.noMatches': 'No public channel matches “%@”.',
    'web.people.create.public': 'Public',
    'web.people.create.private': 'Private',
    'web.people.create.nameHint': 'Between 2 and 64 characters.',
    'web.people.profile.localTime': 'Local time',
    'web.people.profile.deactivated': 'This account is deactivated. You can read the conversation history, but you cannot send new messages.',
    'web.people.profile.deactivatedBadge': 'Deactivated',
    'web.people.profile.copyUsername': 'Copy @username',
    'web.people.profile.copied': 'Copied',
    'web.people.profile.you': 'You',
  },
};
